import React, { useEffect, useMemo, useState } from 'react';
import { Checker } from '../../checkSquare/Checker';
import { tier1, tier2, tier3 } from '../../../data/tiers';

export interface IPriceTableValueDisplay {
    tierNo: number;
    itemKey: string;
}

export const PriceTableValueDisplay: React.FC<IPriceTableValueDisplay> = (props) => {
    const { tierNo, itemKey } = props;

    const [checked, setChecked] = useState<boolean | undefined>(undefined);
    const [percentage, setPercentage] = useState<number | undefined>(undefined);
    const [amount, setAmount] = useState<number | undefined>(undefined);
    const [number, setNumber] = useState<number | undefined>(undefined);

    const tier = useMemo(() => {
        if (tierNo === 1) return tier1;
        if (tierNo === 2) return tier2;
        if (tierNo === 3) return tier3;
    }, [tierNo]);

    useEffect(() => {
        if (!tier) return;

        // Find key in tier object and determine if it's a boolean (checked) or a number ( amount) or key includes "percentage" (percentage)
        if (itemKey in tier) {
            if (typeof tier[itemKey] === 'boolean') {
                setChecked(tier[itemKey]);
            } else if (itemKey.toLowerCase().includes('percentage')) {
                if (tier[itemKey] !== null) {
                    setPercentage(tier[itemKey] as number);
                }
            } else if (itemKey.toLowerCase().includes('price')) {
                if (tier[itemKey] !== null) {
                    setAmount(tier[itemKey] as number);
                }
            } else {
                if (tier[itemKey] !== null) {
                    setNumber(tier[itemKey] as number);
                }
            }
        }
    }, [itemKey, tier]);

    const nothingSelected: boolean = useMemo(() => {
        return (
            checked === undefined &&
            percentage === undefined &&
            amount === undefined &&
            number === undefined
        );
    }, [amount, checked, number, percentage]);

    return (
        <span className="text-xs font-medium text-neutral-50 md:text-xl">
            {checked !== undefined && <Checker checked={checked} />}
            {percentage !== undefined && <span>{percentage} %</span>}
            {number !== undefined && <span>{number}</span>}
            {amount !== undefined && (
                <span>
                    {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR',
                    }).format(amount)}
                </span>
            )}
            {nothingSelected && <span className="text-neutral-600">–</span>}
        </span>
    );
};
